import { Box, Title } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { useMetaplansList } from 'domains/Catalog/Subscriptions/hooks';
import { MetaplansListDesktopSkeleton, MetaplansListTable } from './components';
import { MetaplansListPageBase } from '../MetaplansListPageBase';

export function MetaplansListDesktopPage(): JSX.Element {
  const t = useTranslationCatalog();
  const { metaplans, isLoading, isError, isEmpty, refetch } =
    useMetaplansList();

  return (
    <MetaplansListPageBase
      skeleton={<MetaplansListDesktopSkeleton />}
      isLoading={isLoading}
      isEmpty={isEmpty}
      isError={isError}
      onRetry={refetch}
    >
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="6">
        <Title as="h4">{t('subscriptions.plansTitle')}</Title>
        <Box flexDirection="column" gap="2" display="flex">
          <MetaplansListTable data={metaplans} />
        </Box>
      </Box>
    </MetaplansListPageBase>
  );
}
